import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Params, Router } from '@angular/router';
import { Observable, distinctUntilChanged, filter, map, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouterService {

  constructor(
    private router: Router,
    ) {}


  /**
     * The route params.
     */
  readonly routeParams$: Observable<Params> = this.router.events.pipe(
    filter(event => event instanceof NavigationEnd),
  ).pipe(
    map(_ => this.getCurrentRouteParams()),
    distinctUntilChanged(),
);

/**
 * Gets the observable of a specific route param.
 */
routeParamByName(paramName: string, defaultValue: string): Observable<string> {
  return this.routeParams$.pipe(
    map(params => params[paramName] ?? defaultValue),
    distinctUntilChanged<string>(),
  );
}

/**
 * Gets the current params in the activated route.
 */
getCurrentRouteParams(): Params {

  let params: any = {};
  let stack: ActivatedRouteSnapshot[] = [this.router.routerState.snapshot.root];

  while (stack.length > 0) {
      const route = stack.pop()!;
      params = {...params, ...route.params};
      stack.push(...route.children);
  }

  return params;

}
}
